import { render, staticRenderFns } from "./IconCountBadge.vue?vue&type=template&id=bb952aa2&scoped=true&"
import script from "./IconCountBadge.vue?vue&type=script&lang=ts&"
export * from "./IconCountBadge.vue?vue&type=script&lang=ts&"
import style0 from "./IconCountBadge.vue?vue&type=style&index=0&id=bb952aa2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb952aa2",
  null
  
)

export default component.exports